module.exports = __webpack_public_path__ + "img/90961.13287ebc.svg";